import type { MouseEvent } from 'react';
import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

interface SMModalProps {
  showModal: boolean;
  handleCancel: () => void;
  handleYes?: (e: MouseEvent<HTMLButtonElement>, id?: unknown) => void;
  title: string;
  subTitle?: string;
  msg_line1?: string;
  msg_line2?: string;
  information?: boolean;
  cancelText: string;
  yesText?: string;
  id?: unknown;
}

export default function SMModal({
  showModal,
  handleCancel,
  handleYes,
  title,
  subTitle,
  msg_line1,
  msg_line2,
  information,
  cancelText,
  yesText,
  id
}: SMModalProps) {
  return (
    <Dialog open={showModal} onClose={handleCancel}>
      <DialogTitle>
        <Typography variant="h1">{title}</Typography>
        {subTitle && (
          <Typography variant="h2" sx={{ display: 'block' }}>
            {subTitle}
          </Typography>
        )}
      </DialogTitle>

      <DialogContent dividers>
        {information ? (
          <Typography variant="bodyMedium">{msg_line1}</Typography>
        ) : (
          <Alert severity="warning">
            {msg_line1 && <AlertTitle>{msg_line1}</AlertTitle>}
            {msg_line2}
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          variant={information ? 'primary' : 'secondary'}
          onClick={handleCancel}
        >
          {cancelText}
        </Button>
        {handleYes && yesText && (
          <Button
            variant={information ? 'secondary' : 'primary'}
            onClick={(e) => handleYes(e, id)}
          >
            {yesText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
